module.exports = __webpack_public_path__ + "static/media/natwest-map.66db4ec9.jpg";